import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { taskSchemaObject } from '../taskSchema'
import { validateProperty, validate } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, TextField } from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Tooltip from '@mui/material/Tooltip';
import { AlertDialog } from '../../../Common/AlertDialog';


const screenCode = 'TASK';

export function TaskAddEdit(props) {

    const { data, edit, searchForm } = props.location
    const [title, setTitle] = useState("Add Task")
    const [openDialog, setOpenDialog] = React.useState(false);

    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [taskType, setTaskType] = useState();
    const [taskCategory, setTaskCategory] = useState();
    const [employeeTypes, setEmployeeTypes] = useState();
    const [tableData, setTableData] = useState({
        employeeTypeID: "0",
        applyMethodID: "0",
        minRate: "",
        maxRate: "",
        applyTypeID: "",
        defaultRate:""

    }); 
    const [array, setArray] = useState([]);
    const [task, setTask] = useState({
        taskID: '',
        groupID: "0",
        operationEntityID: "0",
        estateTaskID: "0",
        taskCode: '',
        taskName: '',
        taskDescription: '',
        measuringUnit: '',
        budgetexpensescode: '',
        createdBy: parseInt(tokenService.getUserIDFromToken()),
        isRate: false,
        isActive: true,

    });

    const [buttonName, setButtonName] = useState("Save");
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"

    })

    const [pageProperties, setPageProperties] = useState({
        title: 'Add Task',
        submitButtonName: 'Save',
        passwordFieldDisabled: false
    })

    const schema = Joi.object(taskSchemaObject).options({ allowUnknown: true })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [del, setDel] = useState({
        row: '',
        index: ''
    });
    const confirmButtonProps = {
        color: 'primary',
        variant: 'contained',
        size: 'large'
    };

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [task.groupID]);

    useEffect(() => {
        trackPromise(
            getTaskNames()
        )
    }, [task.operationEntityID]);


    useEffect(() => {
        trackPromise(getEmployeeTypesForDropdown());

    }, []);

    async function getEmployeeTypesForDropdown() {
        const result = await services.GetEmployeeTypesData();
        setEmployeeTypes(result);
    }

    // POPUP function
    async function handleDelete2(row, index) {
        setEnableConfirmMessage(true);
        setDel({
            ...del,
            row: row,
            index: index
        })
    }
    function confirmData(y) {
        if (y) {
            handleDelete(del.row, del.index);
        }
    }

    //popUP End


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITTASK');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            setTitle("Edit Task");
            setTask(data);
            const result = await GetRates(data);
            setButtonName("Update");

        } else {
            setTitle("Add Task");
            var token = tokenService.getUserDetailsFromToken();
            setTask({
                ...task,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }
        trackPromise(
            getAllGroups(),
            getTaskTypes()
        )
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            groupID: target.value,
            operationEntityID: '0'
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            operationEntityID: target.value
        })
    }

    function handleTaskCodeChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            taskCode: target.value
        })
    }

    function handleTaskNameChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            taskName: target.value
        })
    }

    function handleTaskDescriptionChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            taskDescription: target.value
        })
    }

    function handleMeasuringUnitChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            measuringUnit: target.value
        })
    }

    function handleBudgetexpensescodeChange(target) {
        setTask({
            ...task,
            budgetexpensescode: target.value
        })
    }
    function handleActiveChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            isActive: target.checked
        })
    }

    function handleTaskCategoryChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            estateTaskID: target.value,
        });
    }

    function handleSwitchRateChange(target) {
        setTask({
            ...task,
            isRate: target.checked,
        });
    }

    function handleEmployeeTypeChange(e) {
        const target = e.target
        const value = target.value
        setTableData({
            ...tableData,
            [e.target.name]: parseInt(value)
        });

    }

    function handleApplyMethodChange(target) {
        setTableData({
            ...tableData,
            applyMethodID: parseInt(target.value),
        });
    }

    function handleApplyTypeChange(target) {
        setTableData({
            ...tableData,
            applyTypeID: parseInt(target.value),
        });
    }

    function handleRateChange(e) {
        const target = e.target
        const value = target.value

        setTableData({
            ...tableData,
            [e.target.name]: parseFloat(value),
        });
    }


    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, taskSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
    }

    async function handleSave(e) {
        e.preventDefault()

        const errorMessages = validate(schema, task)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return
        saveEdit();
    }

    async function GetRates() {
        const result = await services.getRates(data.taskID);
        setArray(result);
    }

    async function DeleteRates(employeeTaskTemplateRateID, taskID) {
        const response = await services.deleteRates(employeeTaskTemplateRateID, taskID);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        setTimeout(() => {
            modalDismissHandler()
        }, 1500);
    }

    async function saveEdit() {
        if (!edit) {
            const response = await services.saveTask(task, array);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        if (edit) {
            const response = await services.editTask(task, array);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                props.history.push({ pathname: '/task' })
            }, 1500);
        }
    }

    const handleDelete = (row, id) => {

        if (edit == true) {
            DeleteRates(row.employeeTaskTemplateRateID, data.taskID)
            const updatedData = array.filter((row, index) => index !== id);
            setTask({
                ...task,
                isRate: updatedData.length == 0 ? false : true
            })
            setArray(updatedData);
        }

        else {
            const updatedData = array.filter((row, index) => index !== id);
            setTask({
                ...task,
                isRate: updatedData.length == 0 ? false : true
            })
            setArray(updatedData);
        }
    };


    const handleEdit = (row, id) => {

        const newArray = array.filter((array, i) => i !== id);
        setArray(newArray);
        setTableData({
            ...tableData,
            employeeTypeID: row.employeeTypeID,
            applyMethodID: row.applyMethodID,
            minRate: row.minRate,
            maxRate: row.maxRate,
            applyTypeID: row.applyTypeID,
            defaultRate: row.defaultRate
        })

    };

    function addTabledata() {
        if (array.length == 0) {
            if (tableData.minRate > 0 && tableData.maxRate > 0) {
                setArray(
                    [...array, { employeeTypeID: tableData.employeeTypeID, applyMethodID: tableData.applyMethodID, minRate: tableData.minRate, maxRate: tableData.maxRate, applyTypeID: tableData.applyTypeID, defaultRate: tableData.defaultRate }]
                );

                setTableData({
                    ...tableData,
                    employeeTypeID: "0",
                    applyMethodID: "0",
                    minRate: "",
                    maxRate: "",
                    applyTypeID:"0",
                    defaultRate:""
                })
            }

        }
        else {
            if ((tableData.employeeTypeID != array[0].employeeTypeID) && (array.length < 2)) {

                if (tableData.minRate > 0 &&  tableData.maxRate > 0) {
                    setArray(
                        [...array, { employeeTypeID: tableData.employeeTypeID, applyMethodID: tableData.applyMethodID, minRate: tableData.minRate, maxRate: tableData.maxRate, applyTypeID: tableData.applyTypeID, defaultRate: tableData.defaultRate }]
                    );

                    setTableData({
                        ...tableData,
                        employeeTypeID: "0",
                        applyMethodID: "0",
                        minRate: "",
                        maxRate: "",
                        applyTypeID:"0",
                        defaultRate:""
                    })
                }
            }
            else {
                setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Employee Type Already Exist" })
                setTimeout(() => {
                    modalDismissHandler();
                }, 2000);
            }
        }
    }

    async function getEstates() {
        const result = await services.GetAllOperationEntityByGroupID(task.groupID)
        setEstates(result)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getTaskTypes() {
        const result = await services.getTaskTypes(task)
        setTaskType(result)
    }

    async function getTaskNames() {
        const result = await services.getAllTaskNames(task.groupID, task.operationEntityID);
        setTaskCategory(result);
    }



    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function clearButton() {

        setTask({
            ...task,
             groupID: "0",
             operationEntityID: "0",
            estateTaskID: "0",
            taskCode: '',
            taskName: '',
            taskDescription: '',
            measuringUnit: '',
            budgetexpensescode: '',
            isActive: true
        });
        setErrors({});

    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/task"
                                />
                            </div>
                            <hr />
                            <form onSubmit={(e) => handleSave(e)}>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            disabled={edit}
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            value={task.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={task.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateTaskID">Task Category *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="estateTaskID"
                                            name="estateTaskID"
                                            value={task.estateTaskID}
                                            onChange={(e) => handleTaskCategoryChange(e.target)}>
                                            <MenuItem value="0">--Select Task Category--</MenuItem>
                                            {generateDropDownMenu(taskCategory)}
                                        </Select>
                                        {errors["taskCategory"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["taskCategory"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="taskCode">Task Code *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="taskCode"
                                            id="taskCode"
                                            onChange={(e) => handleTaskCodeChange(e.target)}
                                            value={task.taskCode}
                                        />
                                        {errors["taskCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["taskCode"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="taskName">Task Name *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="taskName"
                                            id="taskName"
                                            onChange={(e) => handleTaskNameChange(e.target)}
                                            value={task.taskName}
                                        />
                                        {errors["taskName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["taskName"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="taskDescription">Task Description *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="taskDescription"
                                            id="taskDescription"
                                            onChange={(e) => handleTaskDescriptionChange(e.target)}
                                            value={task.taskDescription}
                                        />
                                        {errors["taskDescription"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["taskDescription"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="measuringUnit">Measuring Unit *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="measuringUnit"
                                            id="measuringUnit"
                                            onChange={(e) => handleMeasuringUnitChange(e.target)}
                                            value={task.measuringUnit}
                                        />
                                        {errors["measuringUnit"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["measuringUnit"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="budgetexpensescode">Budget expenses code</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="budgetexpensescode"
                                            id="budgetexpensescode"
                                            onChange={(e) => handleBudgetexpensescodeChange(e.target)}
                                            value={task.budgetexpensescode}
                                        />
                                    </div>
                                </div>
                                <label htmlFor="switch1" >Active</label>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="isActive"
                                            switch="none"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleActiveChange(e.target)}
                                            checked={task.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>


                                <label htmlFor="switch1">Rate</label>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="isRate"
                                            switch="none"
                                            type="checkbox"
                                            name="isRate"
                                            onChange={(e) => handleSwitchRateChange(e.target)}
                                            checked={task.isRate}
                                        />
                                        <label
                                            htmlFor="isRate"
                                            data-on-label="Yes"
                                            data-off-label="No"
                                        ></label>
                                    </div>
                                </div>
                                <br />

                                {task.isRate ?
                                    (

                                        <Grid container spacing={2}>
                                            <br />
                                            <Box sx={{ width: '60%' }}>
                                                <Paper elevation={6}>
                                                    <Grid container spacing={3}
                                                        columnSpacing={3}
                                                        justifyContent="space-around"
                                                    >
                                                        <Grid xs={3}>
                                                            <div className="form-group row">
                                                                <div className="col-md">
                                                                    <InputLabel shrink id="applyMethodID">
                                                                        Employee Type *
                                                                    </InputLabel>
                                                                    <Select
                                                                        fullWidth
                                                                        label="Employee Type *"
                                                                        id="employeeTypeID"
                                                                        name="employeeTypeID"
                                                                        value={tableData.employeeTypeID}

                                                                        onChange={(e) => handleEmployeeTypeChange(e)}>
                                                                        <MenuItem value="0">--Select Employee Type--</MenuItem >
                                                                        {generateDropDownMenu(employeeTypes)}
                                                                    </Select>
                                                                </div>
                                                            </div>
                                                        </Grid>

                                                        <Grid xs={3}>
                                                            <div className="form-group row" >
                                                                <div className="col-md">
                                                                    <InputLabel shrink id="applyMethodID">
                                                                        Apply Method *
                                                                    </InputLabel>
                                                                    <Select
                                                                        fullWidth
                                                                        id="applyMethodID"
                                                                        name="applyMethodID"
                                                                        value={tableData.applyMethodID}
                                                                        onChange={(e) => handleApplyMethodChange(e.target)}
                                                                    >
                                                                        <MenuItem value="0">--Select Apply Method--</MenuItem>
                                                                        {/* <MenuItem value="1">Daily</MenuItem> */}
                                                                        <MenuItem value="2">Hourly</MenuItem>
                                                                    </Select>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                        <Grid xs={3}>
                                                            <div className="form-group row" >
                                                                <div className="col-md">
                                                                    <InputLabel shrink id="applyTypeID">
                                                                        Apply Type *
                                                                    </InputLabel>
                                                                    <Select
                                                                        fullWidth
                                                                        id="applyTypeID"
                                                                        name="applyTypeID"
                                                                        value={tableData.applyTypeID}
                                                                        onChange={(e) => handleApplyTypeChange(e.target)}
                                                                    >
                                                                        <MenuItem value="0">--Select Apply Type--</MenuItem>
                                                                        <MenuItem value="1">Percentage</MenuItem>
                                                                        <MenuItem value="2">Flat</MenuItem>
                                                                    </Select>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                        <Grid xs={3}>
                                                        <div className="form-group row" >
                                                                <div className="col-md">
                                                                    <InputLabel shrink id="defaultRate">
                                                                        Default Rate *
                                                                    </InputLabel>

                                                                    <TextField
                                                                        fullWidth
                                                                        type="number"
                                                                        name="defaultRate"
                                                                        id="defaultRate"
                                                                        onChange={(e) => handleRateChange(e)}
                                                                        value={tableData.defaultRate}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                        </Grid>
                                                        <Grid container spacing={4}
                                                        columnSpacing={4}
                                                        justifyContent="space-around"
                                                    >
                                                        <Grid xs={4}>
                                                            <div className="form-group row" >
                                                                <div className="col-md">
                                                                    <InputLabel shrink id="minRate">
                                                                        Min Rate *
                                                                    </InputLabel>

                                                                    <TextField
                                                                        fullWidth
                                                                        type="number"
                                                                        name="minRate"
                                                                        id="minRate"
                                                                        onChange={(e) => handleRateChange(e)}
                                                                        value={tableData.minRate}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Grid>


                                                        <Grid xs={4}>
                                                            <div className="form-group row" >
                                                                <div className="col-md">
                                                                    <InputLabel shrink id="maxRate">
                                                                        Max Rate *
                                                                    </InputLabel>

                                                                    <TextField
                                                                        fullWidth
                                                                        type="number"
                                                                        name="maxRate"
                                                                        id="maxRate"
                                                                        onChange={(e) => handleRateChange(e)}
                                                                        value={tableData.maxRate}
                                                                    />
                                                                </div>
                                                            </div>
                                                            

                                                            <Grid
                                                                container spacing={5}
                                                                direction="column"
                                                                justifyContent="flex-end"
                                                                alignItems="flex-end"
                                                            >

                                                                <Tooltip>
                                                                    <IconButton
                                                                        onClick={addTabledata}
                                                                        disabled={(tableData.employeeTypeID && tableData.applyMethodID && tableData.minRate && tableData.maxRate) <= 0}

                                                                    >
                                                                        <AddBoxIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>
                                                        </Grid>

                                                        {array.length > 0 ? (
                                                            <Grid xs={12}>

                                                                <TableContainer>
                                                                    <Table>
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell align="center"><b>Employee Type</b></TableCell>
                                                                                <TableCell align="center"><b>Apply Method</b></TableCell>
                                                                                <TableCell align="center"><b>Apply Type</b></TableCell>
                                                                                <TableCell align="center"><b>Default Rate</b></TableCell>
                                                                                <TableCell align="center"><b>Min Rate</b></TableCell>
                                                                                <TableCell align="center"><b>Max Rate</b></TableCell>
                                                                                <TableCell align="center"><b>Actions</b></TableCell>

                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {array.map((row, index) => {
                                                                                return <TableRow key={index}>
                                                                                    <TableCell align="center" >{row.employeeTypeID == 1 ? "Registered" : "Contract"}
                                                                                    </TableCell>
                                                                                    <TableCell align="center" >{row.applyMethodID == 1 ? "Daily" : "Hourly"}
                                                                                    </TableCell>
                                                                                    <TableCell align="center" >{row.applyTypeID == 1 ? "Percentage" : "Flat"}
                                                                                    </TableCell>
                                                                                    <TableCell align="center" >{row.defaultRate}
                                                                                    </TableCell>
                                                                                    <TableCell align="center" >{row.minRate}
                                                                                    </TableCell>
                                                                                    <TableCell align="center" >{row.maxRate}
                                                                                    </TableCell>
                                                                                    <TableCell align="center" >
                                                                                        <IconButton onClick={() => handleEdit(row, index)}
                                                                                            disabled={(tableData.employeeTypeID || tableData.applyMethodID || tableData.minRate || tableData.maxRate) > 0}
                                                                                        >
                                                                                            <Edit />
                                                                                        </IconButton>
                                                                                        <IconButton onClick={() => handleDelete2(row, index)
                                                                                        }
                                                                                            disabled={(tableData.employeeTypeID || tableData.applyMethodID || tableData.minRate || tableData.maxRate) > 0}
                                                                                        >
                                                                                            <Delete />
                                                                                        </IconButton>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            })}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>

                                                        )
                                                            : null}
                                                    </Grid>


                                                </Paper>
                                            </Box>


                                        </Grid>
                                    )
                                    : null}

                                < MessageModal
                                    hidden={messageModel.hidden}
                                    messageType={messageModel.type}
                                    messageDescription={messageModel.disciption}
                                    clicked={modalDismissHandler}
                                />
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, task)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                        onClick={handleSave}
                                    />
                                    <input
                                        type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={clearButton}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div >
            </div >
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
            <Grid item>

                <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                    discription={"Are you sure want to Delete Rates?"} setViewPopup={setEnableConfirmMessage}
                />

            </Grid>
        </Fragment >
    );
}